import VueRouter from "vue-router";
import store from "./store";

function authGuard(from, to, next) {
  debugger;
  if (store.state.auth.authenticated) {
    next();
  } else {
    next(false);
  }
}

function defaultRedirect(target) {
  console.log(store.state.auth);
  if (store.state.auth.authenticated) {
    return "/customers/" + store.state.auth.user.cardCode;
  } else {
    return "/login";
  }
}
export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: defaultRedirect,
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Auth/page"),
    },
    {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: () => import("./views/Restart/page.vue"),
    },
    {
      path: "/",
      beforeEnter: authGuard,
      redirect: defaultRedirect,
      component: () => import("./views/AppLayout"),
      children: [
        {
          name: "products",
          path: "products",
          component: () => import("./views/products/page.vue"),
        },
        {
          name: "product",
          path: "products/:type",
          component: () => import("./views/products/page.vue"),
          props: true,
        },
        {
          name: "customer",
          path: "customers/:id",
          component: () => import("./views/Customer"),
          props: true,
        },
        {
          path: "cart",
          component: () => import("./views/Cart"),
        },
        {
          name: "checkout",
          path: "checkout",
          component: () => import("./views/Checkout"),
        },
        {
          name: "summary",
          path: "summary",
          component: () => import("./views/Summary"),
        },
        {
          path: "reports",
          component: () => import("./views/Reports"),
        },
        {
          path: "login",
          component: () => import("./views/Authentication"),
        },
      ],
    },
  ],
});
